import Button from 'parkdepot-shared/components/Buttons/Button'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons/types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import DisabledMapWrapper, { ButtonContainer, DisabledMapText } from './style/DisabledMapWrapper.styled'

const DisabledMap = () => {
    const { t } = useTranslation()
    return (
        <DisabledMapWrapper>
            <DisabledMapText>{t('search.enableGoogleMapsCookies')}</DisabledMapText>
            <ButtonContainer>
                <Button
                    id="cookie-settings-btn"
                    $size={BUTTON_SIZE.large}
                    $kind={BUTTON_KIND.tertiary}
                    onClick={(e: any) => {
                        e.preventDefault()
                        if (window.UC_UI) {
                            window.UC_UI.showSecondLayer()
                        } else {
                            console.error('Usercentrics is not loaded yet.')
                        }
                    }}
                >
                    {t('footer.cookieSettings')}
                </Button>
            </ButtonContainer>
        </DisabledMapWrapper>
    )
}

export default DisabledMap
